var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notification-list" },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "right" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "0.2rem" },
              attrs: { type: "primary" },
              on: { click: _vm.markAllAsRead },
            },
            [_vm._v("全部标记为已读")]
          ),
        ],
        1
      ),
      _vm._l(_vm.notifications, function (notification) {
        return _c(
          "div",
          {
            key: notification.id,
            class: ["notification-item", { unread: notification.unread }],
            on: {
              click: function ($event) {
                return _vm.openNotification(notification)
              },
            },
          },
          [
            _c("div", { staticClass: "notification-header" }, [
              _c("div", [
                !notification.readStatus
                  ? _c("span", { staticClass: "unread-dot" })
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "notification-time" }, [
                _vm._v(_vm._s(_vm.getRelativeTime(notification.createTime))),
              ]),
            ]),
            _c("div", { staticClass: "notification-content" }, [
              _c("i", {
                staticClass: "el-icon-bell",
                staticStyle: { "margin-right": "5px" },
              }),
              _vm._v(_vm._s(notification.content) + " "),
            ]),
            _c(
              "div",
              { staticClass: "notification-actions" },
              [
                !notification.readStatus
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.markAsRead(notification)
                          },
                        },
                      },
                      [_vm._v("标记已读 ")]
                    )
                  : _vm._e(),
                notification.messageType === 3 &&
                notification.oprationStatus === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.agreeInquiry(notification)
                          },
                        },
                      },
                      [_vm._v(_vm._s(notification.oprationBtuName) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#f56c6c" },
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.deleteNotification(notification)
                      },
                    },
                  },
                  [_vm._v("删除 ")]
                ),
              ],
              1
            ),
          ]
        )
      }),
      _vm.notifications.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _c("i", { staticClass: "fas fa-bell" }),
            _c("h3", [_vm._v("暂无通知")]),
            _c("p", [_vm._v("您还没有收到系统通知")]),
          ])
        : _vm._e(),
      _c("Pagination", {
        attrs: {
          currentPage: Number(_vm.page),
          pageSizes: [10, 20, 30, 40],
          parentPageSize: Number(_vm.size),
          totalNumber: _vm.totalNumber,
        },
        on: { loadTable: _vm.loadTable },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }